<template>
  <div>
    <h6 v-if="label || $slots.default" class="mb-50">
      <slot>
        {{ label }}
      </slot>
    </h6>
    <div style="height: 37px" class="d-flex align-items-center">
      <span>
        {{ value }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
  },
};
</script>
